import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
//import styled from "styled-components";

//const STYLE = styled.div``;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0.5px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
};

export default function InfoModal({
  success = false,
  open = false,
  error = "",
  customErrorTitle = "",
  button = null,
}) {
  const [openModal, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [open]);

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {success ? "Success" : customErrorTitle || "Error"}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {success ? "Your request has been processed." : error}
        </Typography>
        {button && (
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {button}
          </div>
        )}
      </Box>
    </Modal>
  );
}
